/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import {
  getTheme,
  FontSizes,
  FontWeights,
  IButtonStyles,
  IDatePickerStyles,
  IStackTokens,
  ITextStyles,
} from "office-ui-fabric-react";
import styled from "styled-components";

import { IComboBoxStyles, IDropdownStyles } from "@fluentui/react";

const theme = getTheme();

/**
 * Div containing all of the sidebar components.
 */
export const SideBarDiv = styled.div`
  width:20rem
  max-width: 20rem
  padding-right: 1rem;
  margin-right: 1rem;
  position: relative;
  .content {
    display: "block", 
  }
`;

/**
 * Styles for title at top of sidebar.
 */
export const titleStyles: ITextStyles = {
  root: {
    fontSize: FontSizes.xLarge,
    lineHeight: FontSizes.xxLarge,
    color: theme.palette.blue,
    fontWeight: FontWeights.semibold,
    display: "block",
  },
};

/**
 * Token settings for vertical stack of filters
 */
export const filterStackTokens: IStackTokens = { childrenGap: 20 };

/**
 * Styles for the expand/collapse icon
 */
export const expandCollapseIconStyles: IButtonStyles = {
  root: {
    position: "absolute",
    right: 10,
    top: 10,
  },
  icon: {
    fontSize: FontSizes.small,
    fontWeight: FontWeights.semibold,
    color: theme.palette.blue,
  },
};

/**
 * Text to be clicked that trigger clearing of field's value
 */
export const ClearDateText = styled.p`
  font-size: ${FontSizes.small};
  font-weight: ${FontWeights.regular};
  color: ${theme.palette.blue};
  margin-top: 2px !important;
  margin-bottom: 1px !important;
  text-align: right;
  position: relative;
  &:hover {
    cursor: pointer;
  }
`;

/**
 * Styles for each combobox in the sidebar
 */
export const comboStyles: Partial<IComboBoxStyles> = {
  container: {
    marginTop: "6px !important",
    width: "11rem",
  },
};

/**
 * Styles for each dropdown in the sidebar
 */
export const dropdownStyles: Partial<IDropdownStyles> = {
  root: {
    marginTop: "6px !important",
  },
  dropdown: {
    border: "0.4px",
    borderRadius: "2px",
    width: "11rem",
  },
};

/**
 * Styles for each date picker in the sidebar
 */
export const datePickerStyles: Partial<IDatePickerStyles> = {
  root: {
    marginTop: "5px !important",
    width: "11rem",
  },
  callout: {
    selectors: {
      [".js-goToday"]: { position: "fixed", right: 10 },
    },
  },
};
